import { Button } from '@/components/ui/button'
import { pushModal } from '@/components/modals'
import { useTranslations } from 'next-intl'
import { cn } from '@/lib/utils'

interface InvitationButtonProps {
  variant?: 'light' | 'dark'
}

export const InvitationButton = ({
  variant = 'dark',
}: InvitationButtonProps) => {
  const t = useTranslations('invitation-button')

  function handleClick() {
    pushModal('ReferralModal')
  }

  return (
    <Button
      variant="transparent"
      onClick={handleClick}
      className={cn(
        'text-xs md:text-sm px-3 py-2 md:px-4 md:py-2 h-8 md:h-10 max-w-[140px] md:max-w-[180px] lg:max-w-[200px] truncate',
        variant === 'light'
          ? 'text-black hover:bg-black/5 bg-black/5'
          : 'text-white hover:bg-white/20 bg-white/10',
      )}
    >
      <span className="sm:hidden text-xs truncate">{t('free_credit')}</span>
      <span className="hidden sm:inline text-sm md:text-base truncate">
        {t('share_and_free_credit')}
      </span>
    </Button>
  )
}
